import React, { useState, useEffect } from "react";
import "./ResortExperience.css";
import AvailabilityModal from "./AvailabilityModal";
import ConfirmationModal from './ConfirmationModal'
import { Link } from "react-router-dom";
const ResortExperience = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showAvailabilityModal, setShowAvailabilityModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedDates, setSelectedDates] = useState(null);

  const handleBookNowClick = () => {
    setShowAvailabilityModal(true);
  };

  const handleConfirm = (formData) => {
    setSelectedDates(formData);
    setShowAvailabilityModal(false);
    setShowConfirmationModal(true);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const section = document.querySelector('.resort-experience-section');
    if (section) {
      observer.observe(section);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className={`resort-experience-section ${isVisible ? 'visible' : ''}`} id="about" >
      {/* Background decorative elements */}
      <div className="background-elements">
        <div className="floating-element element-1"></div>
        <div className="floating-element element-2"></div>
        <div className="floating-element element-3"></div>
      </div>

      <div className="resort-experience-content">
        {/* Enhanced Image Section */}
        <div className="image-wrapper">
          <div className="image-container">
            <img
              src="/gal5.jpg"
              alt="Resort"
            />
            {/* <div className="image-overlay">
              <div className="play-button">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z"/>
                </svg>
              </div>
            </div> */}
          </div>
          <div className="image-decoration"></div>
        </div>

        {/* Enhanced Text Content */}
        <div className="text-content">
          <div className="section-badge">
            <span>✨ Premium Experience</span>
          </div>
          <h2>Your All-Inclusive<br />Resort Experience</h2>
          <p>
          Celebrate life’s most cherished moments at one of Bihar’s finest resort destinations. Whether it's a grand wedding, an intimate engagement, or an elegant reception, our resort offers the perfect blend of tradition and luxury. Surrounded by lush greenery and tranquil views, we provide beautifully decorated indoor halls and expansive outdoor lawns to make your event truly unforgettable. From customized décor to gourmet catering and comfortable accommodations, every detail is designed to turn your celebration into a magical experience.
          </p>
          <div className="cta-section">
        <button onClick={handleBookNowClick} className="book-btn primary">
          <span>BOOK NOW</span>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M5 12h14m-7-7l7 7-7 7" />
          </svg>
        </button>
        <button className="book-btn secondary">
     <Link to='/about' className="secondary">EXPLORE MORE</Link>
        </button>
      </div>

      <AvailabilityModal
        isOpen={showAvailabilityModal}
        onClose={() => setShowAvailabilityModal(false)}
        onConfirm={handleConfirm}
      />

      <ConfirmationModal
        isOpen={showConfirmationModal}
        onClose={() => setShowConfirmationModal(false)}
        data={selectedDates}
      />
        </div>
      </div>

      {/* Enhanced Services Section */}
      <section className="our-services">
        <div className="services-header">
          <div className="section-badge">
            <span>🎯 What We Offer</span>
          </div>
          <h2>Our Premium Services</h2>
          <p>Discover the exceptional experiences that make Sangam Resort & Banquet unforgettable</p>
        </div>
        
        <div className="services-grid">
          <div className="service-card">
            <div className="service-image">
              <img src="/image1.jpg" alt="Waterpark" />
              <div className="service-overlay">
                <div className="service-icon">🏊‍♂️</div>
                <h3>Luxury Rooms</h3>
                <p>Comfortable accommodations</p>
              </div>
            </div>
          </div>
          
          <div className="service-card">
            <div className="service-image">
              <img src="/gal9.jpg" alt="Resort Aerial View" />
              <div className="service-overlay">
                <div className="service-icon">🏨</div>
                <h3>Big wedding </h3>
                <p>Comfortable accommodations</p>
              </div>
            </div>
          </div>
          
          <div className="service-card">
            <div className="service-image">
              <img src="/image2.jpg" alt="Conference Hall" />
              <div className="service-overlay">
                <div className="service-icon">🎪</div>
                <h3>Event Venues</h3>
                <p>Perfect for celebrations</p>
              </div>
            </div>
          </div>
          
        </div>
      </section>
    </section>
  );
};

export default ResortExperience;